import { getInstance as getBootstrap } from 'utils/bootstrap';
import get from 'lodash/get';
import Logger from 'observability/Logger';
import SplashApiClientV2 from './SplashApiClientV2';

const LOG = new Logger('SplashApiClientV2-singleton');
let apiClient;

export default () => {
    if (apiClient) {
        return apiClient;
    }

    const bootstrap = getBootstrap();
    const { splashApiUrl, splashApiAccessToken } = get(bootstrap, 'data.app', {});

    if (!splashApiUrl || !splashApiAccessToken) {
        LOG.debug('[SplashApiClientV2] singleton - no api url or token.', {
            splashApiUrl,
            hasSplashApiAccessToken: Boolean(splashApiAccessToken),
        });
    }

    apiClient = new SplashApiClientV2({
        baseUrl: splashApiUrl,
        accessToken: splashApiAccessToken,
    });

    return apiClient;
};

export const setApiClient = (newApiClient) => (apiClient = newApiClient);
